module.exports = __webpack_public_path__ + "static/media/reminders_big.4228c6ee.png";